import './styles/icon-button.css';

// Icon-only control: the visible glyph is decorative, the accessible name
// comes from `label`, and `badge` adds a count (or a dot when `true`).
export default function IconButton({ icon, label, badge, tone = 'neutral', isActive = false, className, ...props }) {
    const hasBadge = badge === true || (typeof badge === 'number' && badge > 0);
    return (
        <button
            type="button"
            className={[
                'icon-button',
                `icon-button--${tone}`,
                isActive && 'icon-button--active',
                className,
            ].filter(Boolean).join(' ')}
            aria-label={label}
            title={label}
            {...props}
        >
            {icon}
            {hasBadge && (
                <span className={`icon-button__badge${badge === true ? ' icon-button__badge--dot' : ''}`} aria-hidden="true">
                    {badge === true ? '' : badge}
                </span>
            )}
        </button>
    );
}
